interface BookOpenProps {
    className?: string;
}

export default function BookOpen({ className = "" }: BookOpenProps) {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 48 48" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path 
                d="M5 7H16C20.4183 7 24 10.5817 24 15V42C24 38.6863 21.3137 36 18 36H5V7Z" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinejoin="round"
            />
            <path 
                d="M43 7H32C27.5817 7 24 10.5817 24 15V42C24 38.6863 26.6863 36 30 36H43V7Z" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinejoin="round"
            />
        </svg>
    );
}

